import { createAction } from 'redux-actions';

export const APP_VIEWER_GLOSSARY_IS_OPEN_SET =
  'APP_VIEWER_GLOSSARY_IS_OPEN_SET';

export default createAction(APP_VIEWER_GLOSSARY_IS_OPEN_SET);
